import React from 'react';

function PhoneIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M6.6 10.8a15.9 15.9 0 006.6 6.6l2.2-2.2c.3-.3.8-.4 1.2-.3 1.3.4 2.7.6 4.1.6.7 0 1.3.6 1.3 1.3V20c0 .7-.6 1.3-1.3 1.3C10.9 21.3 2.7 13.1 2.7 2.7 2.7 2 3.3 1.4 4 1.4h3.5c.7 0 1.3.6 1.3 1.3 0 1.4.2 2.8.6 4.1.1.4 0 .9-.3 1.2L6.6 10.8z"
        fill="currentColor"
      />
    </svg>
  );
}

function MailIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M4 6.5A2.5 2.5 0 016.5 4h11A2.5 2.5 0 0120 6.5v11A2.5 2.5 0 0117.5 20h-11A2.5 2.5 0 014 17.5v-11zm1.8-.5 6.2 4.65L18.2 6H5.8zm13.7 2.35-6.45 4.84a1.2 1.2 0 01-1.45 0L5.5 8.35V17.5c0 .55.45 1 1 1h11c.55 0 1-.45 1-1V8.35z"
        fill="currentColor"
      />
    </svg>
  );
}

function LocationIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M12 2.8a6.2 6.2 0 00-6.2 6.2c0 4.65 6.2 12.2 6.2 12.2s6.2-7.55 6.2-12.2A6.2 6.2 0 0012 2.8zm0 8.4a2.2 2.2 0 110-4.4 2.2 2.2 0 010 4.4z"
        fill="currentColor"
      />
    </svg>
  );
}

function BuildingIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M5 21V4.5A1.5 1.5 0 016.5 3h7A1.5 1.5 0 0115 4.5V21H5zm2-15h1.5v1.5H7V6zm0 3h1.5v1.5H7V9zm0 3h1.5v1.5H7V12zm3-6H11.5v1.5H10V6zm0 3H11.5v1.5H10V9zm0 3H11.5v1.5H10V12zm5 6h2.5V6.5A1.5 1.5 0 0119 5h.5v16H15z"
        fill="currentColor"
      />
    </svg>
  );
}

export function BrowseContactLink({ kind = 'phone', value, className = '' }) {
  const text = String(value || '').trim();
  if (!text) {
    return <span className={`recv-browse-contact recv-browse-contact--empty${className ? ` ${className}` : ''}`}>—</span>;
  }

  const href = kind === 'mail' ? `mailto:${text}` : `tel:${text.replace(/\s+/g, '')}`;
  const Icon = kind === 'mail' ? MailIcon : PhoneIcon;

  return (
    <a
      className={`recv-browse-contact recv-browse-contact--${kind}${className ? ` ${className}` : ''}`}
      href={href}
      onClick={(ev) => ev.stopPropagation()}
    >
      <span className="recv-browse-contact__icon">
        <Icon />
      </span>
      <span className="recv-browse-contact__text">{text}</span>
    </a>
  );
}

export function BrowseMetaChip({ kind = 'location', children, className = '' }) {
  const icons = {
    location: LocationIcon,
    building: BuildingIcon
  };
  const Icon = icons[kind] || LocationIcon;
  const label = String(children || '').trim() || '—';

  return (
    <span className={`recv-browse-meta-chip recv-browse-meta-chip--${kind}${className ? ` ${className}` : ''}`}>
      <span className="recv-browse-meta-chip__icon">
        <Icon />
      </span>
      <span className="recv-browse-meta-chip__text">{label}</span>
    </span>
  );
}

export function BrowseTypePill({ children, tone = 'neutral' }) {
  return (
    <span className={`recv-browse-type-pill recv-browse-type-pill--${tone}`}>{children || '—'}</span>
  );
}
